var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "main_menu/errors") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,17.172 C0,26.561 7.611,34.172 17,34.172 C26.389,34.172 34,26.561 34,17.172 C34,7.783 26.389,0.172 17,0.172 C7.611,0.172 0,7.783 0,17.172 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_menu/errors",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47,49 L12,49 C9.791,49 8,47.209 8,45 L8,12 C8,9.791 9.791,8 12,8 L47,8 C49.209,8 51,9.791 51,12 L51,45 C51,47.209 49.209,49 47,49",
    id: "Fill-1",
    fill: "#E04622"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#FFFFFF",
    points: "14 34.9996 35 34.9996 35 32.9996 14 32.9996"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFFFFF",
    points: "14 40.9996 31 40.9996 31 38.9996 14 38.9996"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(30.000000, 30.828600)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,26.1714 L-13,26.1714 C-15.209,26.1714 -17,24.3804 -17,22.1714 L-17,-10.8286 C-17,-13.0376 -15.209,-14.8286 -13,-14.8286 L22,-14.8286 C24.209,-14.8286 26,-13.0376 26,-10.8286 L26,22.1714 C26,24.3804 24.209,26.1714 22,26.1714",
    id: "Fill-7",
    fill: "#F76E3C",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-5 10.171 18 10.171 18 6.171 -5 6.171"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-5 19.171 18 19.171 18 15.171 -5 15.171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1,17.1714 C-1,20.4534 -0.107,23.5214 1.428,26.1714 L9.081,26.1714 C6.584,23.9724 5,20.7604 5,17.1714 C5,10.5444 10.373,5.1714 17,5.1714 C20.589,5.1714 23.801,6.7554 26,9.2524 L26,1.5994 C23.351,0.0644 20.282,-0.8286 17,-0.8286 C7.059,-0.8286 -1,7.2304 -1,17.1714",
    id: "Fill-13",
    fillOpacity: 0.3,
    fill: "#313036",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(13.000000, 11.828600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,36.1714 C18,27.3494 25.178,20.1714 34,20.1714 C42.822,20.1714 50,27.3494 50,36.1714 C50,44.9934 42.822,52.1714 34,52.1714 C25.178,52.1714 18,44.9934 18,36.1714 Z M59.186,55.3424 L50.811,46.9674 C52.819,43.8494 54,40.1484 54,36.1714 C54,25.1434 45.028,16.1714 34,16.1714 C22.972,16.1714 14,25.1434 14,36.1714 C14,47.1994 22.972,56.1714 34,56.1714 C38.162,56.1714 42.03,54.8904 45.235,52.7054 L53.529,61.0004 L59.186,55.3424 Z",
    id: "Fill-15",
    fill: "#BEC0C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,10.171 L10,10.171 L10,4.171 L8,4.171 L8,10.171 Z M8,14.171 L10,14.171 L10,12.171 L8,12.171 L8,14.171 Z M17.576,13.179 L10.736,1.21 C9.969,-0.133 8.031,-0.133 7.264,1.21 L0.424,13.179 C-0.338,14.512 0.625,16.171 2.16,16.171 L15.84,16.171 C17.375,16.171 18.338,14.512 17.576,13.179 Z",
    id: "Fill-18",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrors);
export default __webpack_public_path__ + "static/media/errors.249ff5d640d90619e5c718f39a8dbd3e.svg";
export { ForwardRef as ReactComponent };